<template>
    <div style="height:100%;">
        <vxe-modal v-model="showForm"
                   :title="selectRow ? '编辑&保存' : '新增&保存'"
                   width="800" min-width="600" min-height="300"
                   :loading="submitLoading"
                   resize destroy-on-close>
            <template #default>
                <vxe-form :data="formData"
                          :key="timer"
                          :items="formItems"
                          :rules="formRules"
                          title-align="right"
                          title-width="100"
                          @submit="submitEvent"
                          size="mini">
                </vxe-form>
            </template>
        </vxe-modal>
        <vxe-toolbar custom perfect v-if="isShowToolbar">
            <template #buttons>
                <vxe-button mode="text" v-for="(toolbarbtn,index) in datatableToolbars" :key="index" :icon="toolbarbtn.icon" :content="toolbarbtn.content" @click="toolbarClick(toolbarbtn.clickEvent)"></vxe-button>
            </template>
        </vxe-toolbar>

        <vxe-table stripe
                   resizable
                   border
                   highlight-current-row
                   highlight-hover-row
                   size="small"
                   align="left"
                   ref="TTable"
                   :seq-config="{startIndex: TableStartIndex}"
                   :data="tableData"
                   :loading="getDataLoading"
                   @cell-dblclick="cellDBLClickEvent"
                   :filter-config="{remote: true}"
                   @filter-change="serverFilterChange"
                   :sort-config="{remote: true,multiple: true}"
                   @sort-change="serverSortChange">

            <vxe-column type="checkbox" width="40" :visible="isShowCheck&&!tableIsSingleCheck"></vxe-column>
            <vxe-column type="radio" width="40" :visible="isShowCheck&&tableIsSingleCheck"></vxe-column>
            <vxe-column type="seq" title="序号" width="50"></vxe-column>
            <vxe-column v-for="(tableColumn,index) in VisibleTableColumns"
                        :key="index"
                        :field="tableColumn.Field"
                        :type="tableColumn.IsFormat && tableColumn.FormatOption.type === 'html' ? 'html' : ''"
                        :title="tableColumn.Title === '' ? tableColumn.Field : tableColumn.Title"
                        :formatter="isDtFormat?formatDataTable:null"
                        :filters="tableColumn.IsFilter?tableColumn.FilterOption.filters:null"
                        :filter-multiple="IsFilterMulti(tableColumn)"
                        :sortable="tableColumn.IsSort"
                        show-overflow
                        highlight-hover-row>
                <template #filter="{ $panel, column }" v-if="tableColumn.FilterOption&&tableColumn.FilterOption.type==='string'">
                    <div v-for="(option, index) in column.filters" :key="index" class="vxe-filter-item">
                        <span>{{option.label}}</span>
                        <input type="text" class="vxe-filter-input" v-model="option.data" @input="$panel.changeOption($event, !!option.data, option)" @keyup.enter="$panel.confirmFilter()">
                    </div>
                </template>
                <template #filter="{ $panel, column }" v-else-if="tableColumn.FilterOption&&tableColumn.FilterOption.type==='number'">
                    <div v-for="(option, index) in column.filters" :key="index" class="vxe-filter-item">
                        <span>{{option.label}}</span>
                        <input type="text" class="vxe-filter-input" v-model="option.data" @input="$panel.changeOption($event, !!option.data, option)" @keyup.enter="$panel.confirmFilter()">
                    </div>
                </template>
                <template #filter="{ $panel, column }" v-else-if="tableColumn.FilterOption&&tableColumn.FilterOption.type==='datetime'">
                    <div v-for="(option, index) in column.filters" :key="index" class="vxe-filter-item">
                        <span>{{option.label}}</span>
                        <input type="datetime-local" class="vxe-filter-input" v-model="option.data" @input="$panel.changeOption($event, !!option.data, option)" @keyup.enter="$panel.confirmFilter()">
                    </div>
                </template>
                <template #default="{ row }" v-if="tableColumn.Field==='Attachment'">
                    <attachment-list :Id="row.Id*1" :table-name="tableName" :row-title="row.Name"></attachment-list>
                    <vxe-button mode="text" icon="vxe-icon-upload" @click="uploadAttachment(row)"></vxe-button>
                </template>
            </vxe-column>
        </vxe-table>

        <vxe-pager background
                   size="small"
                   :current-page="tablePage.PageIndex"
                   :page-size="tablePage.PageSize"
                   :total="tablePage.totalResult"
                   :page-sizes="[10, 20, 50,100]"
                   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                   @page-change="handlePageChange">
        </vxe-pager>
        <vxe-modal v-model="modalDialog.isShow" :title="modalDialog.title" :width="modalDialog.width" min-width="600" min-height="300" @zoom="handlerDialogZoom" resize destroy-on-close>
            <template #default>
                <component
                           :uploadActionUrl="modalDialog.params.uploadactionurl"
                           :externalTip="modalDialog.params.externalTip"
                           :meta="{'title':modalDialog.title}"
                           :callbackParam="modalDialog.params.callbackparams"
                           :tableFilterColsParamOut="modalDialog.params.tablefiltercolsparamout"
                           :is="modalDialog.component"
                           :tableName="modalDialog.params.tablename"
                           :treeJsonData="modalDialog.params.menu"
                           :Id="modalDialog.params.Id"
                           @close="handlerClose"
                           @change="handlerChangeData">

                </component>
            </template>
        </vxe-modal>
      <tdt-mini-map class="baidu-datatable-map" v-if="isMapShow" :isshowclose="true" :mapcenter="mapCenter" :showPos="clickpos" @closemap="handlerCloseMap" @getMapClickCoordinate="handlerGetMapClickCoordinate"></tdt-mini-map>
    </div>
</template>

<script>
    import Plotly from 'plotly.js-dist'
    import { tableInfo2, getListPage, updateEntity, newEntity, deleteEntity, generateDataset, getAttachFile, downloadFile } from '@/api/utils';
    import { PropertyExtend } from '@/utils/validate'
    import XEUtils from 'xe-utils';
    import TdtMiniMap from '@/components/TdtMiniMap.vue'
    import Treejson from '@/components/Treejson'
    import QueryPlotchart from '@/components/QueryPlotchart'
    import UploadFile from '@/components/UploadFile.vue'
    import AttachmentList from "@/components/attachmentList.vue";

    export default {
        name: 'Datatable',
        props: {
            tableName: {
                type: String
            },
            tableFilterColsParamOut: {
                type: Array,
                default:()=>[]
            },
            tableColumnsOut: {
                type: Array,
                default: () => []
            },
            isShowToolbar: {
                type: Boolean,
                default: true
            },
            isShowCheck: {
                type: Boolean,
                default: true
            },
            isShowSort: {
                type: Boolean,
                default:true
            },
            isShowFilter: {
                type: Boolean,
                default:true
            },
            isSingleCheck: {
                type: Boolean,
                default: true
            },
            isDbClick: {
                type: Boolean,
                default: true
            },
            isDtFormat: {
                type: Boolean,
                default: true
            },
            meta: {
                type: Object
            },
            callbackParam: {
                type: Object
            }
        },
        components: {
            TdtMiniMap,
            // TdtMapMini,
            Treejson,
            QueryPlotchart,
            UploadFile: UploadFile,
            AttachmentList
        },
        data() {
            return {
                tableIsSingleCheck: this.isSingleCheck,
                timer: "",
                modalTimer:"",
                uploadActionUrl: '/Attachment/Uploader',
                eleDialog: {
                    isShow: false,
                    title: ''
                },
                modalDialog: {
                    isShow: false,
                    title: '',
                    component: '',
                    width: 800,
                    params: {}
                },
                getDataLoading: true,
                selectRow: null,
                tablePage: {
                    PageIndex: 1,
                    PageSize: 20,
                    OrderField: [],
                    OrderType:[],
                    totalResult: 0
                },
                tableColumns:[],
                tableData: [],
                tableFilterColsParam: [],
                showForm: false,
                submitLoading: false,
                deleteIds:[],
                formData: {},
                formRules: {},
                formItems: [],
                editformmodifycontent: {},
                isMapShow: false,
                clickpos: {
                    prop:'',
                    left: '30px',
                    top:'30px'
                },
                mapCenter: {
                    lng: '',
                    lat:''
                }
            }
        },
        async created() {
            await this.getTableCols();
            this.getTableData();
        },
        mounted() {
            var _this = this;
            window.goToNewComponent = function (tablename, filtercolid, title, componentName, titleprefx, id) {
                _this.goToNewComponent(tablename, filtercolid, title, componentName, titleprefx, id);
            }
            window.modalNewComponent = function (title, titleprefx, component, params) {
                _this.modalNewComponent(title, titleprefx, component, params);
            }
            window.modalNewComponent2 = function (title, titleprefx, component, params) {
                _this.modalNewComponent2(title, titleprefx, component, params);
            }
            window.downloadfile = async function (id) {
                let res = await getAttachFile({ id: id }).catch(() => { });
                downloadFile(res);
                _this.$message({
                    message: "附件下载成功",
                    type: 'success'
                });
            }
        },
        computed: {
            datatableToolbars: function () {
                return this.$store.getters.toolbar.filter(item => {
                    if (item.tablename == undefined || item.tablename.indexOf(this.tableName)>-1) return true;
                });
            },
            //自动计算翻页后的起始索引号
            TableStartIndex() {
                return this.tablePage.PageSize * (this.tablePage.PageIndex - 1);
            },
            //获取可在DataTable中显示的列数组
            VisibleTableColumns: function () {
                var vscols = this.tableColumns.filter(item => item.IsVisibleInTable);
                vscols.forEach(item => {
                    item.IsFilter = this.isShowFilter ? item.IsFilter : false;
                    item.IsSort = this.isShowSort ? item.IsSort : false;
                });
                return vscols;
            }
        },
        watch: {
            showForm: {
                handler(newVal) {
                    if (!newVal)
                        this.isMapShow = newVal;
                }
            },
            tableFilterColsParamOut: {
                handler() {
                    this.getTableData();
                }
            }
        },
        methods: {
            //获取:DataTable列定义
            async getTableCols() {
                let params = { tableName: this.tableName };
                let res = await tableInfo2(params).catch(() => { });
                let tableColumnsRes = res.Data;
                //循环cols
                //1.构建filters
                //2.rules和foreign做eval处理
                //3.对于foreign的列,构建options
                for (let i = 0; i < tableColumnsRes.length; i++) {
                    let col = tableColumnsRes[i];
                    await this.setColumnForeign(col);
                    col.FormatOption = col.FormatOption == null || col.FormatOption === '' ? {} : JSON.parse(col.FormatOption);
                    this.setColumnFilter(col);
                    this.setFormItem(col);
                    this.setFormRule(col);
                }
                //添加 提交和重置 按钮
                this.formItems.push({
                  align: 'center',
                  span: 24,
                  titleAlign: 'left',
                  itemRender: {
                    name: '$buttons',
                    children: [
                        { props: { type: 'submit', content: '提交', status: 'primary'} }]
                  }
                });
                //如果外置columns存在，那么合并两个json串
                if (this.tableColumnsOut.length > 0) {
                    var newcolsdef = [];
                    this.tableColumnsOut.forEach(item => {
                        var colRes = tableColumnsRes.find(itemres => itemres.Id === item.Id);
                        if (colRes !== undefined) {
                            PropertyExtend(colRes, item);
                        } else {
                            newcolsdef.push(item);
                        }
                    });
                }
                this.tableColumns = newcolsdef && newcolsdef.length > 0 ? tableColumnsRes.concat(newcolsdef) : tableColumnsRes;
            },
            //获取:DataTable数据，根据列数组进行保留
            getTableData() {
                let that = this;
                this.getDataLoading = true;
                let tableFilterColsParamTotal = this.tableFilterColsParamOut.length > 0 ? this.tableFilterColsParam.concat(this.tableFilterColsParamOut) : this.tableFilterColsParam;
                let params = {
                    pageQuery: JSON.stringify(this.tablePage),
                    filterColumns: JSON.stringify(tableFilterColsParamTotal)
                };
                getListPage(this.tableName, params).then(response => {
                    that.tableData = response.Data.list.map((item) => {
                        let dataItem = {};
                        //仅仅根据columns信息构建tableData,其他column丢弃
                        that.tableColumns.forEach(col => {
                            if(item[col.Field] !== null && item[col.Field] !== undefined) {
                                dataItem[col.Field] = item[col.Field];
                            }else if(col.Foreign !== '' && col.Foreign != null && col.ForeignOption !== undefined && col.ForeignOption != null){
                                const valueId = item[col.Foreign.key];
                                const value = col.ForeignOption.find(opt => opt.value === valueId);
                                if(value !== undefined && value !== null){
                                    dataItem[col.Field] = value.label;
                                }else {
                                    dataItem[col.Field] = "";
                                }
                            }
                        });
                        return dataItem;
                    });
                    that.tablePage.totalResult = response.Data.total;
                    that.getDataLoading = false;
                }).catch(() => { });
            },
            //方法:判断过滤是否多选
            IsFilterMulti(col) {
                if (col.IsFilter) {
                    if (col.FilterOption.type === 'select') return false;
                    else if (col.FilterOption.type === 'checkbox') return true;
                }
                return '';
            },
            //方法:根据列名查找列对象
            findColbyName(name) {
                return this.tableColumns.find((item) => {
                    return item.Field === name;
                });
            },
            //方法:清空编辑表单的数据对象
            resetFormData() {
                let that = this;
                Object.keys(that.formData).forEach(function (key) {
                    that.formData[key] = null;
                });
            },
            //设置:表单项
            setFormItem(col) {
                if (col.IsVisibleInForm && col.EditOption !== "" && col.EditOption != null) {
                    col.EditOption = JSON.parse(col.EditOption);
                    let formItem = {};
                    if (col.Foreign !== '' && col.Foreign != null) {
                        formItem.field = col.Foreign.key;
                    }
                    else {
                        formItem.field = col.Field;
                    }
                    this.formData[formItem.field] = null;
                    formItem.title = col.Title;
                    formItem.span = col.EditOption.type === 'textarea' ? 24 : 12;
                    formItem.itemRender = {};
                    formItem.itemRender.props = {};
                    formItem.itemRender.slots = {};
                    formItem.itemRender.events = {};
                    formItem.itemRender.props.disabled = !col.IsEditable;
                    switch (col.EditOption.type) {
                        case 'input':
                            formItem.itemRender.name = 'VxeInput';
                            if(col.EditOption.edittype === 'datetime' || col.EditOption.edittype === 'date'){
                                formItem.itemRender.name = 'VxeDatePicker';
                                if(col.EditOption.edittype === 'datetime') formItem.itemRender.props = { type: 'datetime' }
                            }else {
                                formItem.itemRender.props.type = col.EditOption.edittype === undefined || col.EditOption.edittype == null || col.EditOption.edittype == '' ? 'text' : col.EditOption.edittype;
                            }
                            formItem.itemRender.props.suffixIcon = col.EditOption.suffixIcon;
                            //if (col.EditOption.suffix)
                            //    formItem.itemRender.slots.suffix = col.EditOption.suffix;

                            if (col.EditOption.click)
                                formItem.itemRender.events.click = this.handlerFormdblclick;
                            if (col.EditOption.dblclick)
                                formItem.itemRender.events.dblclick = this.handlerFormdblclick;
                            if (col.EditOption.suffixClick)
                                formItem.itemRender.events['suffix-click'] = this.handlersuffixclick;
                            break;
                        case 'textarea':
                            formItem.itemRender.name = 'VxeTextarea';
                            formItem.itemRender.props.autosize = {
                                minRows: 2,
                                maxRows: 4
                            };
                            break;
                        case 'radio':
                        case 'switch':
                            //formItem.itemRender.name = '$switch';
                            //formItem.itemRender.props.openLabel = '是';
                            //formItem.itemRender.props.closeLabel = '否';
                            //formItem.itemRender.events = { change: this.switchChange };
                            formItem.itemRender.name = 'VxeRadioGroup';
                            let trueLabel = col.FormatOption.truelabel !== undefined && col.FormatOption.truelabel != null ? col.FormatOption.truelabel : '是';
                            let falseLabel = col.FormatOption.falselabel !== undefined && col.FormatOption.falselabel != null ? col.FormatOption.falselabel : '否';
                            formItem.itemRender.options = [
                                { label: trueLabel, value: true },
                                { label: falseLabel, value: false }];
                            break;
                        case 'select':
                            formItem.itemRender.name = 'VxeSelect';
                            if (col.EditOption.options === undefined || col.EditOption.options === null || col.EditOption.options === '') {
                                formItem.itemRender.options = col.ForeignOption === undefined || col.ForeignOption === null || col.ForeignOption === '' ? [] : col.ForeignOption;
                            }
                            formItem.itemRender.props.multiple = col.EditOption.edittype === 'multiple';
                            if (formItem.itemRender.props.multiple) {
                                formItem.itemRender.props.clearable = true;
                                formItem.itemRender.props['multi-char-overflow'] = -1;
                            }
                            formItem.itemRender.events = { change: this.selectChange };
                            break;
                        case 'checkbox':
                            formItem.itemRender.name = 'VxeCheckboxGroup';
                            if (col.EditOption.options === undefined || col.EditOption.options === null || col.EditOption.options === '') {
                                formItem.itemRender.options = col.ForeignOption === undefined || col.ForeignOption == null || col.ForeignOption === '' ? [] : col.ForeignOption;
                            }
                            break;
                        default:
                    }
                    this.formItems.push(formItem);
                }
            },
            //设置:表单的验证规则
            setFormRule(col) {
                if (col.IsVisibleInForm && col.IsEditable && col.ValidateOption != "" && col.ValidateOption != null) {
                    col.ValidateOption = eval(col.ValidateOption);
                    col.ValidateOption.forEach((rule) => {
                        var keys = Object.keys(rule);
                        if (keys.indexOf('message') === -1) {
                            if (keys.indexOf('required') > -1)
                                rule.message = col.Title + "不为空";
                            else if (keys.indexOf('min') > -1 && keys.indexOf('max') > -1)
                                rule.message = '长度在 ' + rule.min + ' 到 ' + rule.max + ' 个字符';
                            else if (keys.indexOf('min') > -1 && keys.indexOf('max') === -1)
                                rule.message = '长度大于 ' + rule.min + ' 个字符';
                            else if (keys.indexOf('min') === -1 && keys.indexOf('max') > -1)
                                rule.message = '长度小于 ' + rule.max + ' 个字符';
                        }
                    });
                    //如果有外键，那么验证规则字段变为外键字段
                    var ruleField = col.Field;
                    if (col.Foreign != '' && col.Foreign != null) {
                        ruleField = col.Foreign.key;
                    }
                    this.formRules[ruleField] = col.ValidateOption;
                }
            },
            //设置:DataTable的过滤Options
            setColumnFilter(col) {
                if (col.IsFilter && col.FilterOption != null && col.FilterOption != "") {
                    col.FilterOption = JSON.parse(col.FilterOption);
                    switch (col.FilterOption.type) {
                        case 'number'://数字
                            col.FilterOption.filters = [{ data: '', label: '大于' }, { data: '', label: '小于' }, { data: '', label: '包含' }];
                            break;
                        case 'string'://字符串文本
                            col.FilterOption.filters = [{ data: '', label: '包含' }];
                            break;
                        case 'datetime'://时间
                            col.FilterOption.filters = [{ data: '', label: '起始' }, { data: '', label: '结束' }];
                            break;
                        case 'array'://数组 不过滤
                            break;
                        case 'foreign'://外键
                            col.FilterOption.filters = col.ForeignOption === null || col.ForeignOption === '' || col.ForeignOption === undefined ? [] : col.ForeignOption;
                            break;
                        case 'bool':
                            var truelabel = col.FilterOption.truelabel !== undefined && col.FormatOption.truelabel != null ? col.FilterOption.truelabel : '是';
                            var falselabel = col.FormatOption.falselabel !== undefined && col.FormatOption.falselabel != null ? col.FormatOption.falselabel : '否';
                            var nulllabel = col.FormatOption.nulllabel !== undefined && col.FormatOption.nulllabel != null ? col.FormatOption.nulllabel : '空';
                            col.FilterOption.filters = [
                                {
                                    label: truelabel,
                                    value:true
                                },
                                {
                                    label: falselabel,
                                    value: false
                                },
                                {
                                    label: nulllabel,
                                    value: null
                                }
                            ]
                            break;
                        default:
                    }
                }
            },
            //设置:DataTable的外键Options
            async setColumnForeign(col) {
                if (col.Foreign !== "" && col.Foreign != null) {
                    col.Foreign = JSON.parse(col.Foreign);
                    col.Foreign.delay = col.Foreign.delay === undefined ? false : col.Foreign.delay;
                    if (!col.Foreign.delay) {
                        //根据foreign请求数据
                        let res = await getListPage(col.Foreign.table);
                        col.ForeignOption = res.Data.list.map((forItem) => {
                            return {
                                label: forItem[col.Foreign.value],
                                value: forItem[col.Foreign.tablekey]
                            };
                        });
                    }
                }
            },
            //设置:DataTable的外键Options(延迟加载)
            async setColumnForeignDelay(col,data) {
                if (col.Foreign != "" && col.Foreign != null) {
                    col.Foreign.delay = col.Foreign.delay == undefined ? false : col.Foreign.delay;
                    if (col.Foreign.delay) {
                        var filtercol = {
                            filters: [{
                                data: [data[col.Foreign.filterkey]]
                            }],
                            columnname: col.Foreign.filterkey,
                            tablename: col.Foreign.table
                        };

                        //根据foreign请求数据
                        var params = {
                            filterColumns: JSON.stringify([filtercol])
                        };

                        let res = await getListPage(col.Foreign.table,params);
                        col.ForeignOption = res.Data.list.map((forItem) => {
                            return {
                                label: forItem[col.Foreign.value],
                                value: parseInt(forItem[col.Foreign.tablekey])
                            };
                        });
                        //将选中项目置顶
                        col.ForeignOption.map((item, index) => {
                            if (data[col.Foreign.key].indexOf(item.value) > -1) {
                                col.ForeignOption.unshift(col.ForeignOption.splice(index,1)[0]);
                            }
                        });

                        var formitem = this.formItems.find(item => item.field == col.Field);
                        formitem.itemRender.options = col.ForeignOption;
                    }
                }
            },
            //格式化:Form、DataTable
            formatForm(cellValue, column) {
                let reValue = cellValue;
                let col = this.findColbyName(column);
                let enumArray = []
                if (col.IsFormat && col.FormatOption !== "" && col.FormatOption != null && cellValue != null) {
                    switch (col.FormatOption.type) {
                        case 'int':
                            reValue = parseInt(cellValue);
                            break;
                        case 'float':
                        case 'double':
                        case 'number'://数字:保留2位小数
                            reValue = parseFloat(cellValue).toFixed(2);
                            if (col.FormatOption.scale !== undefined && col.FormatOption.scale != null)
                                reValue = col.FormatOption.scale * reValue;
                            break;
                        case 'datetime'://时间:不格式
                            break;
                        case 'array'://数组:根据Option自定义格式化
                            if (col.FormatOption.template !== undefined &&
                                col.FormatOption.template != null &&
                                col.FormatOption.template !== '') {
                                reValue = "";
                                cellValue.forEach(cellItem => {
                                    reValue += XEUtils.toFormatString(col.FormatOption.template, cellItem) + '\r\n';
                                });
                            }
                            else
                                reValue = cellValue.join(',');
                            break;
                        case 'enum':
                            enumArray = col.FormatOption.template;
                            reValue = enumArray[cellValue];
                            break;
                        default:
                    }
                }
                return reValue;
            },
            formatDataTable({ cellValue,row, column }) {
                let reValue = cellValue;
                let col = this.findColbyName(column.property);
                let enumArray = [];
                if (col.IsFormat && col.FormatOption !== "" && col.FormatOption != null) {
                    if (cellValue == null) {
                        reValue = col.FormatOption.nulllabel !== undefined && col.FormatOption.nulllabel != null ? col.FormatOption.nulllabel : '';
                    } else {
                        switch (col.FormatOption.type) {
                            case 'int':
                                reValue = parseInt(cellValue);
                                break;
                            case 'float':
                            case 'double':
                            case 'number'://数字:保留2位小数
                                reValue = parseFloat(cellValue).toFixed(2);
                                break;
                            case 'datetime'://时间:yyyy-MM-dd HH:mm:ss.S 不格式化后支持毫秒
                                reValue = XEUtils.toDateString(cellValue, 'yyyy-MM-dd HH:mm:ss');
                                break;
                            case 'bool':
                                var truelabel = col.FormatOption.truelabel != undefined && col.FormatOption.truelabel != null ? col.FormatOption.truelabel : '是';
                                var falselabel = col.FormatOption.falselabel != undefined && col.FormatOption.falselabel != null ? col.FormatOption.falselabel : '否';
                                reValue = cellValue ? truelabel : falselabel;
                                break;
                            case 'array'://数组:根据Option自定义格式化
                                if (col.FormatOption.template != undefined && col.FormatOption.template != null && col.FormatOption.template != '') {
                                    reValue = "";
                                    cellValue.forEach(cellItem => {
                                        reValue += XEUtils.toFormatString(col.FormatOption.template, cellItem) + '\r\n';
                                    });
                                }
                                else
                                    reValue = cellValue.join(',');
                                break;
                            case 'html':
                                //超链接
                                if (Array.isArray(cellValue)) {
                                    reValue = "";
                                    var backSaveArr = [col.Field, row.Id];
                                    var isbacksave = false;
                                    if (cellValue.length > 0) {
                                        if (col.FormatOption.isBackSave && col.FormatOption.isBackSave == "1") {
                                            isbacksave = true;
                                        }
                                        if (col.FormatOption.isFor && col.FormatOption.isFor == "0") {
                                            reValue = XEUtils.toFormatString(col.FormatOption.template, isbacksave ? [cellValue.join(',')].concat(backSaveArr) : [cellValue.join(',')]);
                                        }
                                        else
                                            cellValue.forEach(cellItem => {
                                                reValue += XEUtils.toFormatString(col.FormatOption.template, isbacksave ? [cellItem].concat(backSaveArr) : [cellItem]) + ' , ';
                                            });
                                    }
                                }
                                else {
                                    reValue = XEUtils.toFormatString(col.FormatOption.template, isbacksave ? [cellValue].concat(backSaveArr) : [cellValue]);
                                }
                                break;
                            case 'array_peaks_mainpage'://mainpage 荧光峰信息
                                if (col.FormatOption.template !== undefined &&
                                    col.FormatOption.template != null &&
                                    col.FormatOption.template !== '') {
                                    reValue = XEUtils.toFormatString(col.FormatOption.template, cellValue[0]);
                                }
                                break;
                            case 'enum':
                                enumArray = col.FormatOption.template;
                                reValue = enumArray[cellValue];
                                break;
                            default:
                        }
                    }

                }
                return reValue;
            },
            //事件:下拉框选择后强制更新
            selectChange(selectControl) {
                // selectControl._clearActived();
                // selectControl._setActiveCell(selectControl.);
              // this.$refs.xTable.clearActived()//清除单元格激活状态
              // this.$refs.xTable.setActiveCell(selectControl.row,selectControl.column.property)//设置单元格为激活状态
                selectControl.$form.$forceUpdate();
            },
            //弹窗缩放事件
            handlerDialogZoom() {
                switch (this.modalDialog.component) {
                    case 'queryPlotchart':
                        Plotly.Plots.resize(document.getElementById(this.modalDialog.params.tablename));
                        break;
                    default:
                }
            },
            //渲染的动态表单的下拉框点击事件
            // switchChange(val, evt) {
            //    this.formData[val.property] = evt.value;
            // },
            //渲染的动态表单的双击事件
            handlersuffixclick(ob, evt) {
                if (ob.data[ob.property] !== "" && ob.data[ob.property]!=null) {
                    let coords = ob.data[ob.property].split(',');
                    this.mapCenter.lng = coords[0];
                    this.mapCenter.lat = coords[1];
                } else {
                    this.mapCenter.lng = 0;
                    this.mapCenter.lat = 0;
                }
                this.clickpos.prop = ob.property;
                this.clickpos.left = (evt.$event.clientX-195) + 'px';
                this.clickpos.top = (evt.$event.clientY-93) + 'px';
                this.isMapShow = !this.isMapShow;
            },
            handlerCloseMap(_isclose) {
                this.isMapShow = _isclose;
            },
            handlerClose(_isclose) {
                this.modalDialog.isShow = _isclose;
            },
            async handlerChangeData(_data) {
                let that = this;
                if (_data.name === 'treejson') {
                    let o = this.tableData.find(x => x.Id === that.modalDialog.params.Id);
                    if (o !== undefined) o.Menu = _data.params;
                } else if (_data.name === 'uploadFile') {//上传完成，回传文件ids
                    //table row col
                    await this.callbackUpdate(that, _data.ids, 1);
                } else {
                    // do nothing
                }
            },
            async callbackUpdate(_T, ids, way) {
                if (_T.callbackParam !== null && _T.callbackParam !== undefined &&
                    JSON.stringify(_T.callbackParam) !== "{}") {
                    let postFormAttach = {};
                    postFormAttach.Id = _T.callbackParam.rowId;
                    if (way === 1) {
                        postFormAttach[_T.callbackParam.colId] = _T.callbackParam.ids.split(',').concat(ids);
                    }
                    else if (way === 2) {
                        var newids = _T.callbackParam.ids.split(',');
                        ids.forEach(id => {
                            newids.remove(id);
                        });
                        postFormAttach[_T.callbackParam.colId] = newids;
                    }
                    let res = await updateEntity(_T.callbackParam.tb, [postFormAttach]).catch(() => { });
                    if (res.Code === 1) {
                        //更新当前过滤参数
                        _T.tableFilterColsParamOut[0].filters[0].data = postFormAttach[_T.callbackParam.colId];
                        _T.callbackParam.ids = postFormAttach[_T.callbackParam.colId].join(',');
                        _T.getTableCols();
                        _T.getTableData();
                    }
                } else {
                    this.getTableData();
                }
            },
            handlerGetMapClickCoordinate(_clickPoint) {
                if (this.clickpos.prop !== "") {
                    this.formData[this.clickpos.prop] = _clickPoint.lng + ',' + _clickPoint.lat;
                    //this.$set(this.formData, this.clickpos.prop, _clickPoint.lng + ',' + _clickPoint.lat);
                    this.timer = new Date().getTime();
                }
            },
            //事件:服务器筛选
            serverFilterChange({ filters }) {
                var that = this;
                this.tableFilterColsParam = filters.map((item) => {
                    var filterItem = {
                        filters:[]
                    };
                    //根据列name获取id,分是否有fors的情况
                    var currentColumn = that.findColbyName(item.property);
                    if (currentColumn.Foreign != '' && currentColumn.Foreign != null) {
                        filterItem.columnid = that.findColbyName(currentColumn.Foreign.key).Id;
                        filterItem.columnname = currentColumn.Foreign.key;
                        filterItem.tablename = that.tableName;
                        filterItem.filters.push({ data: item.values });
                    }
                    else if (currentColumn.FilterOption.type == 'bool')
                    {
                        filterItem.columnid = currentColumn.Id;
                        filterItem.columnname = currentColumn.Field;
                        filterItem.tablename = that.tableName;
                        filterItem.filters.push({ data: item.values });
                    }
                    else {
                        filterItem.columnid = currentColumn.Id;
                        filterItem.columnname = currentColumn.Field;
                        filterItem.tablename = that.tableName;
                        for (var i = 0; i < item.column.filters.length; i++) {
                            var tempdata = item.column.filters[i].data;
                            if (i == 2) {
                                tempdata = item.column.filters[i].data.split(',');
                                if (tempdata == "") tempdata = [];
                            }
                            filterItem.filters.push({ data: tempdata == undefined ? '' : tempdata });
                        }
                    }
                    return filterItem;
                });
                this.getTableData();
            },
            //事件:服务器排序
            serverSortChange({ sortList }) {
                var that = this;
                that.tablePage.OrderField = [];
                that.tablePage.OrderType = [];
                sortList.forEach((item) => {
                    var col = that.findColbyName(item.property);
                    if (col.Foreign == "" || col.Foreign == null) {
                        that.tablePage.OrderField.push(item.property);
                    } else {
                        that.tablePage.OrderField.push(col.Foreign.key);
                    }
                    that.tablePage.OrderType.push(item.order);
                });
                this.getTableData();
            },
            //事件:清除DataTable排序状态
            clearTableSort() {
                this.$refs.TTable.clearSort();
                this.tablePage.OrderField = [];
                this.tablePage.OrderType = [];
                this.getTableData();
            },
            //事件:清除DataTable过滤状态
            clearTableFilter() {
                this.$refs.TTable.clearFilter();
                this.tableFilterColsParam = [];
                this.getTableData();
            },
            //事件:翻页
            handlePageChange({ currentPage, pageSize }) {
                this.tablePage.PageIndex = currentPage;
                this.tablePage.PageSize = pageSize;
                this.getTableData();
            },
            //事件:DataTable单元格双击
            cellDBLClickEvent({ row }) {
                if (this.isDbClick)
                    this.editEvent(row);
            },
            //事件:编辑
            tooleditEvent() {
                const $table = this.$refs.TTable;
                let selectRecords = [];
                if (this.tableIsSingleCheck)
                    selectRecords.push($table.getRadioRecord());
                else
                    selectRecords = $table.getCheckboxRecords();

                if (selectRecords.length === 0 || (selectRecords.length === 1 && selectRecords[0] == null))
                    this.$XModal.message({ content: '请选择一条记录', status: 'info' });
                else if (selectRecords.length > 1) {
                    this.$XModal.alert({ content: '将默认编辑第一条记录', title: '编辑', status: 'info' })
                        .then(type => {
                        if (type === 'confirm') {
                            //跳转到编辑
                            this.editEvent(selectRecords[0]);
                        }
                    });
                }
                else {
                    //跳转到详情页
                    this.editEvent(selectRecords[0]);
                }
            },
            //事件:datatable 超链接 点击事件
            goToNewComponent(tablename, filtercolid, title, componentName, titleprefx, id) {
                // 正对预警处理特别进行代码处理
                if (tablename == 'AlertTreatment')
                    tablename = 'Observation';
                var dtFilterCols = [];
                if (componentName.toLowerCase() == 'datatable') {
                    var filtercol = {
                        filters: [{
                            data: id.split(',')
                        }],
                        columnid: filtercolid,
                        tablename: tablename
                    };
                    dtFilterCols = [];
                    dtFilterCols.push(filtercol);
                }
                var tabItem = {
                    title: title + " [" + id + "]" + (titleprefx == '' ? titleprefx : '-' + titleprefx),
                    icon: '',
                    path: title + id + titleprefx + componentName,
                    component: componentName,
                    params: { tablename: tablename, id: id, filter: dtFilterCols, isshowtoolbar: false, isshowcheck: false, isshowfilter: false, isdbclick:false }
                };
                this.$store.commit('app/ADD_TAB', tabItem);
            },
            //事件:弹出权限编辑对话框
            modalNewComponent(title, titleprefx, component, params) {
                this.modalDialog.title = title + titleprefx;
                this.modalDialog.component = component;
                this.modalTimer = new Date().getTime();
                switch (component) {
                    case 'treejson':
                        this.modalDialog.params.Id = params['Id'];
                        this.modalDialog.params.menu = JSON.parse(params['Menu']);
                        break;
                    case 'queryPlotchart':
                        this.modalDialog.params.tablename = params['tableName'];
                        break;
                    case 'uploadFile':
                        this.modalDialog.params.uploadactionurl = process.env.VUE_APP_BASE_API+params;
                        break;
                    default:
                        break;
                }
                this.modalDialog.isShow = true;
            },
            uploadAttachment(row) {
                this.modalDialog.width = 400;
                this.modalDialog.title = '上传附件至：' + row.Name;
                this.modalDialog.component = 'uploadFile';
                this.modalTimer = new Date().getTime();
                this.modalDialog.params.uploadactionurl = process.env.VUE_APP_BASE_API + this.uploadActionUrl;
                this.modalDialog.params.Id = row.Id;
                this.modalDialog.params.tablename = this.tableName;
                this.modalDialog.isShow = true;
            },
            modalNewComponent2(title, titleprefx, component, params) {
                var dtFilterCols = [];
                var filtercol = {
                    filters: [{
                        data: params['id'].split(',')
                    }],
                    columnid: params['filtercolId'],
                    tablename: params['tableName']
                };
                dtFilterCols =[];
                dtFilterCols.push(filtercol);

                var tabItem = {
                    title: title + '('+params['saverowId']+')' + titleprefx,
                    icon: '',
                    path: title + params['id'] + titleprefx + component,
                    component: component,
                    params: { tablename: params['tableName'], filter: dtFilterCols, isshowtoolbar: true, isshowcheck: true, isshowfilter: false, isdbclick: true, callbackparam: { tb: this.tableName, colId: params['savecol'], rowId: params['saverowId'], ids: params['id'] } }
                };
                this.$store.commit('app/ADD_TAB', tabItem);
            },
            //事件:查看详情 对比溯源
            viewEvent(componentName, titleprefx, way) {//way=1,goto,way=2,modal
                const $table = this.$refs.TTable;
                let selectRecords = [];
                if (this.tableIsSingleCheck)
                    selectRecords.push($table.getRadioRecord());
                else
                    selectRecords = $table.getCheckboxRecords();
                if (componentName === 'queryPlotchart') {
                    this.modalNewComponent(this.meta.title, titleprefx, componentName, { tableName: this.tableName });
                }
                else if (componentName === 'uploadFile') {
                    this.modalNewComponent('', titleprefx, componentName, this.uploadActionUrl);
                }
                else {
                    if (selectRecords.length === 0 || (selectRecords.length === 1 && selectRecords[0] == null))
                        this.$XModal.message({ content: '请选择一条记录', status: 'info' });
                    else if (selectRecords.length > 1) {
                        //selectRecords = selectRecords.map(t => t.Id);
                        this.$XModal.alert({ content: '将默认选择第一条记录', title: '选择', status: 'info' }).then(type => {
                            if (type === 'confirm') {
                                if (way === 1)
                                    this.goToNewComponent(this.tableName, '', this.meta.title, componentName, titleprefx, selectRecords[0].Id);
                                else if (way === 2)
                                    this.modalNewComponent(this.meta.title, titleprefx, componentName, selectRecords[0]);
                            }
                        });
                    }
                    else {
                        if (way === 1)
                            this.goToNewComponent(this.tableName, '', this.meta.title, componentName, titleprefx, selectRecords[0].Id);
                        else if (way === 2)
                            this.modalNewComponent(this.meta.title, titleprefx, componentName, selectRecords[0]);
                    }
                }
            },
            //事件:新增
            insertEvent() {
                this.resetFormData();
                this.selectRow = null;
                this.showForm = true;
            },
            //事件:编辑
            async editEvent(row) {
                var that = this;
                this.resetFormData();
                that.editformmodifycontent = {};
                Object.keys(this.formData).forEach(function (key) {
                    if (row[key] !== undefined)
                        that.formData[key] = that.formatForm(row[key], key);
                    var col = that.findColbyName(key);
                    if (col.IsEditable)
                        that.editformmodifycontent[key] = that.formData[key];
                });
                //延迟加载外键数据options
                for (var i = 0; i < this.tableColumns.length; i++) {
                    var col = this.tableColumns[i];
                    await this.setColumnForeignDelay(col, row);
                }
                this.selectRow = row;
                this.showForm = true;
            },
            //事件:删除
            removeEvent() {
                const $table = this.$refs.TTable;
                let selectRecords = [];
                if (this.tableIsSingleCheck)
                    selectRecords.push($table.getRadioRecord());
                else
                    selectRecords = $table.getCheckboxRecords();

                if (selectRecords.length === 0 || (selectRecords.length === 1 && selectRecords[0] == null))
                    this.$XModal.message({ content: '请选择一条记录', status: 'info' });
                else{
                    this.$XModal.confirm('您确定要删除所选数据?').then(type => {
                        const $table = this.$refs.TTable;
                        if (type === 'confirm') {
                            //var deleteIds = $table.getRemoveRecords().map(t => t.Id);
                            let deleteIds = selectRecords.map(t => t.Id);
                            // let deleteIds = [$table.getRadioRecord()['Id']];
                            let pretitle = "删除";
                            let that = this;
                            deleteEntity(this.tableName, deleteIds).then(async res => {
                                let msg = res.Msg == null || res.Msg === "" ? "" : "," + res.Msg;
                                switch (res.Code) {
                                    case 1://success
                                        $table.removeRadioRow(); //单选
                                        $table.removeCheckboxRow(); // 多选
                                        that.$XModal.message({ content: pretitle + "成功" + msg, status: 'success' });
                                        that.callbackUpdate(that, deleteIds,2);
                                        break;
                                    case 2://error
                                        that.$XModal.message({ content: pretitle + "失败" + msg, status: 'warning' });
                                        break;
                                    case 3://exception
                                        that.$XModal.message({ content: pretitle + "失败" + msg, status: 'error' });
                                        break;
                                    default:
                                }
                            }).catch(() => { });
                        }
                    })
                }
            },
            //事件:提交生成数据集的参数
            async createDataSetEvent() {
                var tableFilterColsParamTotal = this.tableFilterColsParamOut.length > 0 ? this.tableFilterColsParam.concat(this.tableFilterColsParamOut) : this.tableFilterColsParam;
                var params = {
                    filterColumns: JSON.stringify(tableFilterColsParamTotal)
                };
                this.getDataLoading = true;
                let res = await generateDataset(params).catch(() => { });
                if (res.Code == 1) {
                    this.$XModal.message({ content: "生成数据集成功", status: 'success' });
                } else {
                    this.$XModal.message({ content: "生成数据集失败，请稍后再试", status: 'error' });
                }
                this.getDataLoading = false;

            },
            async toolbarClick(funName) {
                let that = this;
                switch (funName) {
                    case 'viewEvent':
                        this.viewEvent('detailinfo','详情',1);
                        break;
                    case 'compareEvent':
                        this.viewEvent('compareObs','溯源',1);
                        break;
                    case 'createDataSetEvent':
                        this.createDataSetEvent();
                        break;
                    case 'manageMenusEvent':
                        this.modalDialog.width = 300;
                        this.viewEvent('treejson', '-配置权限', 2);
                        break;
                    case 'chartEvent':
                        this.modalDialog.width = 1200;
                        this.viewEvent('queryPlotchart', '-查看曲线', 2);
                        break;
                    case 'uploadattachEvent':
                        this.modalDialog.width = 400;
                        this.viewEvent('uploadFile', '上传', 2);
                        break;
                    case 'insertEvent':
                        this.insertEvent();
                        break;
                    case 'tooleditEvent':
                        this.tooleditEvent();
                        break;
                    case 'removeEvent':
                        this.removeEvent();
                        break;
                    case 'clearTableFilter':
                        this.clearTableFilter();
                        break;
                    case 'clearTableSort':
                        this.clearTableSort();
                        break;
                    case 'refreshDataTable':
                        await this.getTableCols();
                        this.getTableData();
                        break;
                    case 'changeMultiSelectStatus':
                        // that.isSingleCheck = !that.isSingleCheck;
                        that.tableIsSingleCheck = !that.tableIsSingleCheck;
                        break;
                    default:
                }
            },
            //事件:提交
            async submitEvent() {
                let that = this;
                let res = null;
                this.submitLoading = true;
                let postFormData = {};
                //获取提交数据
                Object.keys(this.formData).forEach(function (key) {
                    let col = that.findColbyName(key);
                    if (col.IsEditable)
                        postFormData[key] = that.formData[key];
                    if (col.FormatOption.scale)
                        postFormData[key] = postFormData[key] * 1.0 / col.FormatOption.scale;
                });
                // 如果数据有EquipmentId，那么也要将EquipmentId提交上去，方便进行权限验证
                if(that.formData["EquipmentId"] !== null){
                    postFormData["EquipmentId"] = that.formData["EquipmentId"];
                }
                let pretitle = "";
                if (this.selectRow) {
                    //编辑
                    //检查是否有修改内容
                    if (JSON.stringify(this.editformmodifycontent) === JSON.stringify(postFormData))
                        this.$XModal.message({ content: '请编辑后再提交', status: 'warning' });
                    else {
                        postFormData.Id = this.selectRow.Id;
                        pretitle = "编辑";
                        res = await updateEntity(this.tableName, [postFormData]).catch(() => { });
                    }
                }
                else {
                    //新增
                    pretitle = "新增";
                    res = await newEntity(this.tableName, [postFormData]).catch(() => { });
                }
                if (res != null) {
                    switch (res.Code) {
                        case 1://success
                            that.$XModal.message({ content: pretitle + (res.Msg == null ? '成功' : res.Msg), status: 'success' });
                            that.showForm = false;
                            that.getTableData();
                            break;
                        case 2://error
                            that.$XModal.message({ content: pretitle +res.Msg, status: 'warning' });
                            break;
                        case 3://exception
                            that.$XModal.message({ content: pretitle +res.Msg, status: 'error' });
                            break;
                        default:
                    }
                }
                this.submitLoading = false;
            }
        }
    }
</script>

<style scoped>
    .baidu-datatable-map {
        width: 300px;
        height: 250px;
        display: block;
        position: absolute;
        left: 20px;
        top: 20px;
        z-index: 2040;
        border:1px solid #000;
        border-radius:5px;
        overflow:hidden;
    }
</style>
